import {memoize} from 'lodash';

// Loaders call these fetchers during render (some straight inside a useMemo dependency
// array), so evicting a rejected call right away means every render creates a new
// promise: a request storm plus a permanent busy/free cycle. Keep the failure cached
// long enough to break that loop, while still allowing a later retry.
export const FAILED_CALL_TTL = 5000;

export default function memoizePromise(func, resolver = (...args) => args.join('-')) {
    let memoized = memoize((...args) => {
        return func.apply(null, args).catch(err => {
            // lodash keys the cache with resolver(...args)
            setTimeout(() => memoized.cache.delete(resolver(...args)), FAILED_CALL_TTL);
            throw err;
        });
    }, resolver);
    return memoized;
}
